<template>
  <div>
    <v-data-table
      v-bind="$attrs"
      v-on="$listeners"
      :headers="headers"
      :items="items"
      :fixed-header="true"
      :max-height="maxHeight"
      :height="calculatedHeight"
      class="base-data-table"
      :items-per-page="localItemsPerPage"
      @update:items-per-page="(val) => (localItemsPerPage = val)"
    >
      <!-- repassa os slots dinamicamente -->
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'BaseDataTable',
  inheritAttrs: false,
  props: {
    items: { type: Array, required: true },
    headers: { type: Array, required: true },
    dense: { type: Boolean, default: false },
    maxHeight: { type: String, default: '400px' },
    itemsPerPage: { type: Number, default: 10 }, // agora reativo
  },
  data() {
    return {
      localItemsPerPage: this.itemsPerPage,
    }
  },
  computed: {
    calculatedHeight() {
      const { number: maxHeight, unit: maxHeightUnit } =
        this.separateNumberUnit(this.maxHeight)
      const rowHeight = this.dense ? 36 : 48
      const headerHeight = 56
      const footerHeight = this.hideDefaultFooter ? 0 : 56
      const hasTopSlot = typeof this.$scopedSlots.top === 'function'
      const topHeight = hasTopSlot ? 64 : 0
      const perPage = this.localItemsPerPage
      const total = this.items?.length || 0
      const visibleItems =
        perPage === -1
          ? total // "Todos"
          : Math.min(total, perPage || 10)
      const naturalHeight =
        visibleItems * rowHeight + headerHeight + topHeight + footerHeight
      if (naturalHeight > this.convertToPixels(this.maxHeight)) {
        return maxHeight + maxHeightUnit
      }
      return null
    },
  },
  methods: {
    convertToPixels(value) {
      const { number, unit } = this.separateNumberUnit(value)

      switch (unit) {
        case 'px':
          return number
        case 'vh':
          console.log()
          return (window.innerHeight * number) / 100
        case 'vw':
          return (window.innerWidth * number) / 100
        case '%':
          return this.$el?.parentNode
            ? (this.$el.parentNode.clientHeight * number) / 100
            : number
        default:
          return number
      }
    },
    separateNumberUnit(value) {
      const match = String(value).match(/^(\d+)(\D*)$/)
      if (match) {
        return { number: Number(match[1]), unit: match[2] || 'px' }
      }
      return { number: 0, unit: 'px' }
    },
  },
}
</script>
